import { EXPORT_HISTORY_PT_BR } from "#components/export-history/translations";
import { EXPORT_BY_EMAIL_MODAL_PT_BR } from "#components/export-by-email-modal/translations";
import addBillModalForm from "./add-bill-modal-form.json";
import addProduct from "./add-product.json";
import ballStatusIndicator from "./ball-status-indicator.json";
import coalaAddMenuModal from "./coala-add-menu-modal.json";
import coalaAddMenuProductModal from "./coala-add-menu-product-modal.json";
import coalaAddProductModal from "./coala-add-product-modal.json";
import coalaCategorizedProductsTable from "./coala-categorized-products-table.json";
import coalaMassEditModal from "./coala-mass-edit-modal.json";
import components from "./components.json";
import confirmModal from "./confirm-modal.json";
import consolidatedHistory from "./consolidated-history.json";
import containers from "./containers.json";
import dataTable from "./data-table.json";
import dialogs from "./dialogs.json";
import errorBoundary from "./error-boundary.json";
import eventTag from "./event-tag.json";
import formStatus from "./form-status.json";
import forms from "./forms.json";
import globalWarnings from "./global-warnings.json";
import header from "./header.json";
import helpers from "./helpers.json";
import hierarchicalChartAccountsSelector from "./hierarchical-chart-accounts-selector.json";
import inputFile from "./input-file.json";
import monthPicker from "./month-picker.json";
import notAvailable from "./not-available.json";
import notification from "./notification.json";
import notifications from "./notifications.json";
import openSalesReport from "./open-sales-report.json";
import paginator from "./paginator.json";
import pendingContracts from "./pending-contracts.json";
import periodDropdown from "./period-dropdown.json";
import pixTypeInput from "./pix-type-input.json";
import placeCheckbox from "./place-checkbox.json";
import placeFilter from "./place-filter.json";
import reportNavbar from "./report-navbar.json";
import reportPrintTemplate from "./report-print-template.json";
import reportTab from "./report-tab.json";
import reportTabs from "./report-tabs.json";
import selectImage from "./select-image.json";
import tableEmptyState from "./table-empty-state.json";
import xlsx from "./xlsx.json";
import importXlsxDrawer from "./import-xlsx-drawer.json";
import table from "./table.json";
import tabsBackoffice from "./tabs-backoffice.json";
import transactionalHistory from "./transactional-history.json";
import withdrawsCards from "./withdraws-cards.json";
import datahubChat from "./datahub-chat.json";
import { EXPORT_EMAIL_DRAWER_PT_BR } from "#components/export-email-drawer/translations";
import { PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_PT_BR } from "./payment-method-with-cashless-and-bonus";
import reconciliationTransactions from "./reconciliation-transactions.json";

export const componentsPT = {
	...components,
	pixTypeInput,
	periodDropdown,
	confirmModal,
	eventTag,
	paginator,
	dataTable,
	monthPicker,
	notification,
	notAvailable,
	openSalesReport,
	formStatus,
	reportNavbar,
	reportTab,
	selectImage,
	table,
	tabsBackoffice,
	addBillModalForm,
	ballStatusIndicator,
	coalaAddMenuModal,
	coalaAddMenuProductModal,
	coalaAddProductModal,
	coalaCategorizedProductsTable,
	coalaMassEditModal,
	containers,
	dialogs,
	errorBoundary,
	forms,
	globalWarnings,
	consolidatedHistory,
	addProduct,
	pendingContracts,
	reportTabs,
	transactionalHistory,
	helpers,
	withdrawsCards,
	reportPrintTemplate,
	inputFile,
	notifications,
	placeCheckbox,
	placeFilter,
	header,
	tableEmptyState,
	xlsx,
	importXlsxDrawer,
	datahubChat,
	bonusReportTotalizers: {
		receivedValue: "Valor total concedido",
		spentValue: "Produtos pagos com bônus",
		tipValue: "Serviço pago com bônus",
		spentInOtherEvent: "Vendas pagas com bônus em outro período",
		spentTipValueInOtherEvent: "Serviço pago com bônus em outro período",
		receivedValueTooltip: "Total de bônus concedidos no período filtrado",
		spentValueTooltip: "Total de produtos pagos com bônus no período filtrado",
		tipValueTooltip: "Total de serviços pagos com bônus no período filtrado",
		spentInOtherEventTooltip:
			"Total de bônus cedido no período filtrado e que foi utilizado em período diferente sem considerar serviço",
		spentTipValueInOtherEventTooltip:
			"Total de serviço pagos com bônus cedido no período filtrado e que foram utilizados em período diferente",
	},
	"hierarchical-chart-accounts-selector": hierarchicalChartAccountsSelector,
	exportHistory: EXPORT_HISTORY_PT_BR,
	exportEmailDrawer: EXPORT_EMAIL_DRAWER_PT_BR,
	paymentMethodWithCashlessAndBonusLabel: PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_PT_BR,
	reconciliationTransactions,
	exportByEmailModal: EXPORT_BY_EMAIL_MODAL_PT_BR,
};
